import { EventInput } from '@fullcalendar/angular';

let eventGuid = 0;
export function createEventId() {
    return String(eventGuid++);
}

const category = [
    {
        name: '--Select--',
        value: '',
        option: "selected"
    },
    {
      name: 'Danger',
      value: 'bg-danger',
      option: ""
    },
    {
        name: 'Success',
        value: 'bg-success',
        option: ""
    },
    {
        name: 'Primary',
        value: 'bg-primary',
        option: ""
    },
    {
        name: 'Info',
        value: 'bg-info',
        option: ""
    },
    {
        name: 'Dark',
        value: 'bg-dark',
        option: ""
    },
    {
        name: 'Warning',
        value: 'bg-warning',
        option: ""
    }
];
var date = new Date();
var d = date.getDate();
var m = date.getMonth();
var y = date.getFullYear();
const calendarEvents: EventInput[] = [
    {
        id: createEventId(),
        title: 'All Day Eventxxx',
        start: '2023-11-14 17:00:00',
        className: 'bg-soft-success'
    },
    {
        id: createEventId(),
        title: 'All Day Eventxxx',
        start: new Date(y, m, 6),
        end: new Date(y, m, 9),
        className: 'bg-soft-warning'
    }

];

export { category, calendarEvents };
